import { AddressFormData } from 'src/app/_widgets/address-form/address-form-data';
import { BeLiberoProfessionista } from './be-professionista';
import { IFactory, PGEndpointPath } from './i-factory';
import { Impresa } from './impresa';
import {
  LiberoProfessionista,
  TipoContrattoLavoroEnum,
} from './libero-professionista';

export class ProfessionistaFactory
  implements IFactory<BeLiberoProfessionista, LiberoProfessionista>
{
  toView(data: BeLiberoProfessionista) {
    let p: LiberoProfessionista = {
      nome: data.nome,
      cognome: data.cognome,
      ateco: data.ateco,
      denominazione: data.denominazione,
      id: data.id,
      numeroDipendenti: data.numeroDipendenti,
      partitaIva: data.partitaIva,
      pec: data.pec,
      tipoContabilita: 'Semplificata',
      tipoSoggetto: 'LP',
      iban: data.iban,
      dataIscrizioneAlbo: new Date(data.dataIscrizioneAlbo),
      formaGiuridica: data.formaGiuridica,
      codiceAteco: data.codiceAteco,
      confermaPec: data.confermaPec,
      iscrizioneAlbo: data.iscrizioneAlbo,
      numeroIscrizioneAlbo: data.numeroIscrizioneAlbo,
      settoreAttivita: data.settoreAttivita || 'Servizi privati',
      sezioneAteco: data.sezioneAteco,
      annoRilevazioneDipendenti: data.annoRilevazioneDipendenti,
      codiceFiscale: data.codiceFiscale,
      situazioneAbitativa: data.situazioneAbitativa,
      affitto: data.affitto,
      fatturatoUltimoAnno: data.fatturatoUltimoAnno,

      capitaleSocialeDeliberato: data.capitaleSocialeDeliberato,
      capitaleSocialeVersato: data.capitaleSocialeVersato,

      professione: data.professione,
      kic: data.kic,

      immobiliDiProprieta: data.immobiliDiProprieta,

      location: {
        street_number: data.civicoSedeLegale,
        route: data.indirizzoSedeLegale,
        postal_code: data.capSedeLegale,
        administrative_area_level_2: data.provinciaSedeLegale,
        administrative_area_level_3: data.comuneSedeLegale,
      },
    };
    return p;
  }

  toDomain(
    professionista: Partial<LiberoProfessionista>,
    tipoContabilita?: Impresa['tipoContabilita'],
    kycData?: Impresa['kic'] | undefined,
    location: Partial<AddressFormData> = {}
  ) {
    let p: Partial<BeLiberoProfessionista> = {
      annoRilevazioneDipendenti: professionista.annoRilevazioneDipendenti,
      codiceAteco: professionista.codiceAteco,
      cognome: professionista.cognome,
      confermaPec: professionista.confermaPec,
      dataIscrizioneAlbo: professionista.dataIscrizioneAlbo?.valueOf(),
      iscrizioneAlbo: professionista.iscrizioneAlbo,
      nome: professionista.nome,
      numeroIscrizioneAlbo: professionista.numeroIscrizioneAlbo,
      settoreAttivita: professionista.settoreAttivita,
      sezioneAteco: professionista.sezioneAteco,
      ateco: professionista.ateco,
      codiceFiscale: professionista.codiceFiscale,
      denominazione: `${
        (professionista.nome || '') + ' ' + (professionista.cognome || '')
      }`,
      id: professionista.id,
      numeroDipendenti: professionista.numeroDipendenti,
      partitaIva: professionista.partitaIva,
      pec: professionista.pec,
      formaGiuridica: professionista.formaGiuridica,
      civicoSedeLegale: location.street_number,
      indirizzoSedeLegale: location.route,
      capSedeLegale: location.postal_code,
      provinciaSedeLegale: location.administrative_area_level_2,
      comuneSedeLegale: location.administrative_area_level_3,
      situazioneAbitativa: professionista.situazioneAbitativa,
      affitto: professionista.affitto,
      iban: professionista.iban,
      professione: professionista.professione,
      fatturatoUltimoAnno: professionista.fatturatoUltimoAnno,
      immobiliDiProprieta: professionista.immobiliDiProprieta,

      kic: kycData,
    };
    return p;
  }

  endpointPath: PGEndpointPath = 'libero-professionista';
}
